export default __webpack_public_path__ + "locales/es/Article.json?hash=07e0185114f95896c90156a26a431ea8";